import { useBoolean } from '@dreryk/react-common';

import { StatisticsCode } from './StatisticsListTable.types';
import { GenerateStatisticsModal } from './GenerateStatisticsModal';
import { GenerateZD3StatisticsModal } from './GenerateZD3StatisticsModal';
import { GenerateMZ15StatisticsModal } from './GenerateMZ15StatisticsModal';
import { GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModal } from './GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModal';

type GenerateStatisticsModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type GenerateStatisticsModalOpenerProps = {
   readonly children: (renderProps: GenerateStatisticsModalOpenerRenderProps) => JSX.Element;
   readonly code: StatisticsCode;
};

const getStatisticsModal = (code: StatisticsCode, closeModal: VoidFunction): JSX.Element => {
   switch (code) {
      case 'HealthcareProviderCreateZD3ReportStatistics':
         return <GenerateZD3StatisticsModal closeModal={closeModal} />;
      case 'HealthcareProviderCreateMZ15ReportStatistics':
         return <GenerateMZ15StatisticsModal closeModal={closeModal} />;
      case 'HealthcareProviderPatientsWithDiagnosisStatistics':
         return <GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModal closeModal={closeModal} />;
      default:
         return <GenerateStatisticsModal closeModal={closeModal} code={code} />;
   }
};

export const GenerateStatisticsModalOpener = (props: GenerateStatisticsModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? getStatisticsModal(props.code, closeModal) : null}
      </>
   );
};
